import initLinkTracking from "./linkTracking";
import { gravityFormInViewEvent } from "./gravityForms";
import { listenPostEventToParent } from "./postEventToParent";

window.document.addEventListener("DOMContentLoaded", function () {
  listenPostEventToParent();
  initLinkTracking();
  gravityFormInViewEvent();
});

window.document.addEventListener("appDataLoaded", function () {
  initLinkTracking();
});
